<div class="ui-g">
    <div class="ui-g-12" style="margin: 0px; padding: 0px;">

        <app-popover-input #poi></app-popover-input>

        <!-- <p>tipoLista: {{tipoLista}}</p> -->
        <p-table #tt
                 *ngIf="refreshHackFix"
                 [autoLayout]="true"
                 [columns]="lista.cols"
                 [value]="lista.resultset?.content"
                 [responsive]="true"
                 [paginator]="!esconderPaginacao && !hasError"
                 [lazy]="true"
                 [rows]="size"
                 [totalRecords]="totalRegistros"
                 [loading]="loading"
                 (onLazyLoad)="aoMudarPagina($event)"
                 (onRowSelect)="aoSelecionarLinha($event)"
                 selectionMode="single">
            <!-- [rowsPerPageOptions]="[4, 10, 25]" -->

            <ng-template pTemplate="caption" *ngIf="exibirLegenda">
                <div class="ui-helper-clearfix">
                    <button type="button"
                            *ngIf="!esconderBotaoExcel"
                            pButton
                            icon="fa fa-file-excel-o"
                            iconPos="left"
                            (click)="tt.exportCSV()"
                            style="float:left;"></button>

                    <!-- busca-rapida-->
                    <span *ngIf="metadataBuscaRapida"
                          style="float: right;">
                      <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                      <input pInputText
                             #inputBuscaRapida
                             type="text"
                             size="36"
                             placeholder="{{buscaRapidaNomePlaceholder}}"
                             class="filtroGlobal">
                    </span>
                </div>
            </ng-template>

            <ng-template pTemplate="header" let-columns *ngIf="!esconderCabecalho">
              <tr>
                <ng-container *ngFor="let col of columns">
                  <ng-container *ngIf="!col.hidden">

                    <!-- coluna tipo checkbox -->
                    <ng-container *ngIf="col.dataType === _checkboxDataType; else thDemaisColunas">
                      <th [style.text-align]="col.align ? col.align : 'left'"
                          title="{{col.title && col.title !== 'undefined' ? col.title : ''}}"
                          [innerHTML]="col.fieldNameHtml ? col.fieldNameHtml : col.fieldName"
                          (click)="!col.disabled && col.fnClickTitulo ? col.fnClickTitulo($event, resultset, rowIndex, lista, listHandlerService) : (col.disabled ? this.toasterService.warning('Indisponível', 'Você pode não ter permissão.') : '' )">
                      </th>
                    </ng-container>

                    <!-- demais colunas -->
                    <ng-template #thDemaisColunas>
                      <th [pSortableColumn]="col.fieldId && col.sortDirection !== 'none' ? col.fieldId : ''"
                          [style.text-align]="col.align ? col.align : 'left'"
                          title="{{col.title && col.title !== 'undefined' ? col.title : ''}}"
                          [innerHTML]="col.fieldNameHtml ? col.fieldNameHtml : col.fieldName">
                          <!-- <p-sortIcon style="float: left;"
                                      [field]="col.fieldId">
                          </p-sortIcon> -->
                      </th>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-resultset let-columns="columns" let-rowIndex="rowIndex">
                <tr
                  [id]="'listaRow__' + rowIndex"
                  [pSelectableRowDblClick]="getBundle(resultset, columns, rowIndex)">
                    <ng-container *ngFor="let col of columns">
                        <td [hidden]="col.hidden"
                            [ngClass]="{'cell-disabled': col.disabled}"
                            [style.padding]="col.dataType === _checkboxDataType ? '0px 4px'
                                                                                : col.dataType === _buttonDataType ? '0.75px 12.25px'
                                                                                                                   : ''"
                            [style.vertical-align]="col.verticalAlign ? col.verticalAlign : 'middle'"
                            [style.text-align]="col.align ? col.align : 'left'"
                            (click)="(!col.disabled &&
                                      col.fnClick &&
                                      (
                                        !col.fnOperacaoNaoPermitida || (!col.fnOperacaoNaoPermitida(resultset))
                                      )
                                     )
                                     ? col.fnClick($event, resultset, rowIndex, lista, listHandlerService)
                                     : ( col.disabled ? this.toasterService.warning('Indisponível', 'Você pode não ter permissão.')
                                                      : '' )"
                            [id]="'listaCel__' + col.fieldId + '_' + rowIndex"
                            [innerHtml]="resultset | resultsetPipe: col: rowIndex"><pre>{{col.disabled ? 'disable' : 'enabled'}}</pre>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>

            <ng-template pTemplate="footer" let-columns *ngIf="totalRegistros > 0">
              <tr>
                <ng-container *ngFor="let col of columns; let i = index">
                  <td
                    [hidden]="col.hidden"
                    [ngClass]="col.acumular ? 'celula-acumulador' : 'sem-bordas'">
                    <span *ngIf="col.acumular">
                      {{acumuladores[i].valor}}
                    </span>
                  </td>
                </ng-container>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns?.length" style="min-height: 34.5px;">
                  <span *ngIf="!hasError && totalRegistros === 0">Nenhum registro encontrado</span>
                  <span *ngIf="hasError || errorMsg">
                    <font color='red'>
                      {{ errorMsg ? errorMsg : 'Ocorreu um erro na operação' }}
                    </font></span>
                    &nbsp;
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="paginatorleft">
              <span *ngIf="totalRegistros > 0" title="Quantidade de registros encontrados...">
                {{totalRegistros}} registro(s)
              </span>
            </ng-template>
            <!-- do {{state.first + 1}} até o {{(state.rows + 1) * size}} de -->
        </p-table>
    </div>
</div>
